/* rc-enquiry — custom enquiry form behaviour (build-spec §10 / D1).
   - captures UTMs (URL → sessionStorage, persisted) + product_url + page_path
   - WhatsApp number field toggles with the preferred-contact choice
   - submits JSON to form[data-endpoint]; success/error UI; honeypot drop
   - [data-rc-enquiry-open] opens the shared enquiry modal, injecting page context
   Event-delegated + idempotent. NO secrets here — endpoint URL only. Load once, defer. */
(function () {
  if (window.__rcEnquiryInit) return;
  window.__rcEnquiryInit = true;

  /* Analytics: push an enquiry event to GTM dataLayer + GA4 gtag (if present), tagged with the
     horizontal-scroll variant when that section is on the page (for A/B measurement). */
  function rcTrack(name, params) {
    var p = params || {};
    try {
      if (window.__rcHscrollTracked) p.rc_variant = 'horizontal';
      var dl = { event: name }; for (var k in p) dl[k] = p[k];
      (window.dataLayer = window.dataLayer || []).push(dl);
      if (typeof window.gtag === 'function') window.gtag('event', name, p);
    } catch (e) {}
  }

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  /* ---- UTM capture (first non-empty set persists for the session) ---- */
  function captureUTMs() {
    var params = new URLSearchParams(window.location.search);
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('rc_utms') || '{}'); } catch (e) {}
    var hasNew = UTM_KEYS.some(function (k) { return params.get(k); });
    if (hasNew) {
      UTM_KEYS.forEach(function (k) { stored[k] = params.get(k) || ''; });
      try { sessionStorage.setItem('rc_utms', JSON.stringify(stored)); } catch (e) {}
    }
    return stored;
  }

  function fillContext(scope) {
    var utms = captureUTMs();
    (scope || document).querySelectorAll('[data-rc-field]').forEach(function (input) {
      var key = input.getAttribute('data-rc-field');
      if (key === 'product_url') { if (!input.value) input.value = window.location.href; }
      else if (key === 'page_path') { input.value = window.location.pathname; }
      else if (UTM_KEYS.indexOf(key) > -1) { input.value = utms[key] || ''; }
    });
  }

  /* ---- WhatsApp field toggle ---- */
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('input[name="preferred_contact"]');
    if (!radio) return;
    var form = radio.closest('[data-rc-enquiry-form]');
    if (!form) return;
    var wa = form.querySelector('[data-rc-whatsapp]');
    if (!wa) return;
    var on = radio.value === 'WhatsApp' && radio.checked;
    wa.hidden = !on;
    var input = wa.querySelector('input');
    if (input) { input.disabled = !on; input.required = on; }
  });

  /* ---- Submit ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-rc-enquiry-form]');
    if (!form) return;
    e.preventDefault();

    var status = form.querySelector('[data-rc-status]');
    var submit = form.querySelector('[type="submit"]');
    var endpoint = form.getAttribute('data-endpoint');

    function setStatus(msg, type) {
      if (!status) return;
      status.hidden = false;
      status.textContent = msg;
      status.setAttribute('data-state', type || '');
    }

    // Honeypot: silently accept + drop.
    var hp = form.querySelector('input[name="company"]');
    if (hp && hp.value) { form.reset(); setStatus('Thank you — your enquiry has been sent.', 'success'); return; }

    if (!endpoint) { setStatus('Enquiries open soon — please check back shortly.', 'error'); return; }

    if (!form.checkValidity()) { form.reportValidity(); return; }

    fillContext(form);

    var data = {};
    new FormData(form).forEach(function (v, k) { if (k !== 'company') data[k] = v; });
    // Turnstile token (widget injects a hidden input; also try the JS API)
    var token = (form.querySelector('[name="cf-turnstile-response"]') || {}).value || '';
    if (!token && window.turnstile && window.turnstile.getResponse) {
      try { token = window.turnstile.getResponse() || ''; } catch (e) {}
    }
    if (token) data.turnstile_token = token;

    submit.disabled = true;
    setStatus('Sending…', 'pending');

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json().catch(function () { return {}; }); })
      .then(function () {
        form.reset();
        var wa = form.querySelector('[data-rc-whatsapp]');
        if (wa) { wa.hidden = true; var i = wa.querySelector('input'); if (i) { i.disabled = true; i.required = false; } }
        if (window.turnstile && window.turnstile.reset) { try { window.turnstile.reset(); } catch (e) {} }
        setStatus('Thank you — your enquiry has been sent. Our team will be in touch.', 'success');
        rcTrack('enquiry_submit', { method: 'form' });
        submit.disabled = false;
      })
      .catch(function () {
        setStatus('Something went wrong. Please try again, or email us if it persists.', 'error');
        submit.disabled = false;
      });
  });

  /* ---- Modal open (any [data-rc-enquiry-open]) ---- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-rc-enquiry-open]');
    if (trigger) {
      var modal = document.querySelector('[data-rc-enquiry-modal]');
      if (modal) {
        e.preventDefault();
        rcTrack('enquiry_open', { method: 'modal' });
        var form = modal.querySelector('[data-rc-enquiry-form]');
        if (form) {
          // inject page context from the trigger (falls back to current page)
          var map = { car_title: 'rcCarTitle', car_handle: 'rcCarHandle', chassis_code: 'rcChassis', product_url: 'rcUrl' };
          Object.keys(map).forEach(function (field) {
            var el = form.querySelector('[data-rc-ctx="' + field + '"]');
            if (!el) return;
            var v = trigger.getAttribute('data-' + field.replace(/_/g, '-'));
            if (v != null) el.value = v;
          });
          fillContext(form);
        }
        if (typeof modal.showModal === 'function') { if (!modal.open) modal.showModal(); }
        return;
      }
    }
    // modal close / backdrop
    var dlg = document.querySelector('[data-rc-enquiry-modal]');
    if (dlg && dlg.open) {
      if (e.target.closest('[data-rc-enquiry-close]')) { dlg.close(); return; }
      var inner = dlg.querySelector('[data-rc-modal-inner]');
      if (inner && !inner.contains(e.target) && e.target === dlg) dlg.close();
    }
  });

  function init() { fillContext(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { fillContext(e.target); });
})();
